import { Outlet } from "react-router";

const VoucherSetupIndexPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
export default VoucherSetupIndexPage;
